import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SOURCES_AB61, SOURCES_ABTEKA, SOURCES_AS61, STORE_AUTH, STORE_CUSTOMERS, STORE_VIN_QUERIES } from "../../../constants";
import { RouteComponentProps, Link } from "react-router-dom";
import { formatDate, formatMoney } from "../../../common/Formatting";
import { LinkContainer } from "react-router-bootstrap";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { wrapInput, wrapCheckbox } from "../../../common/FormChangeWrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { AuthStore, CustomersStore, Customer, VinQueriesStore, VinQuery } from "../../../stores";
import { SelectCustomerModal } from "../../../components/SelectCustomerModal";
import { NotificationLevel } from "../../../stores/NotificationStore";
registerLocale('ru', ru)

interface IProps {
    history: any,
    [STORE_VIN_QUERIES]: VinQueriesStore,
    [STORE_CUSTOMERS]: CustomersStore
}

interface IState {
    currentPage: number,
    totalCount: number,
    filterFormIsOpened: boolean,
    filteredManagerIds: string[],
    filteredCustomerId: string,
    searchText: string,
    dateFrom?: Date,
    dateTo?: Date,
    source?: string,
    selectCustomerModalIsOpened: boolean,
    selectedCustomerId?: string,
    selectedCustomerName?: string,
    vinQueries: VinQuery[]
    // onlyUnAccepted: boolean,
    // showHidden: boolean
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_VIN_QUERIES, STORE_CUSTOMERS, STORE_AUTH)
@observer
export class VinQueriesPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            totalCount: 0,
            filterFormIsOpened: false,
            searchText: "",
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            source: SOURCES_AS61,
            selectCustomerModalIsOpened: false,
            vinQueries: []
            // onlyUnAccepted: false,
            // showHidden: false
        };
    }

    vinQueriesStore = (this.props as any)[STORE_VIN_QUERIES] as VinQueriesStore;
    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;
    authStore = (this.props as any)[STORE_AUTH] as AuthStore;

    private backUrl = "";

    loadData = () => {
        this.vinQueriesStore.loadVinQueries(
            this.state.selectedCustomerId || "",
            this.state.currentPage,
            this.state.source,
            this.state.dateFrom,
            this.state.dateTo,
            this.state.searchText,
            (vinQueries: VinQuery[], currentPage: number, totalCount: number) => {
                this.setState({
                    currentPage: currentPage,
                    totalCount: totalCount,
                    vinQueries: vinQueries
                })
            });
    }

    componentDidMount() {
        const savedFilter = JSON.parse(localStorage.getItem("vinFilter") || "{}");
        if (savedFilter.dateFrom != null) {
            savedFilter.dateFrom = new Date(savedFilter.dateFrom);
        }
        if (savedFilter.dateTo != null) {
            savedFilter.dateTo = new Date(savedFilter.dateTo);
        }

        this.setState(Object.assign({}, this.state, savedFilter), () => {
            this.loadData();
        });
    }


    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        const prevPage = parseInt(prevProps.match.params.page) || 1;
        const page = parseInt(this.props.match.params.page) || 1;

        this.backUrl = encodeURIComponent("/sales/vinqueries/" + page);

        if (prevPage != page) {
            this.setState({
                currentPage: page
            }, () => {
                this.loadData();
            })
        }
    }

    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            source: SOURCES_AS61,
            searchText: "",
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            dateFrom: undefined,
            dateTo: undefined,
            selectedCustomerId: undefined,
            selectedCustomerName: undefined
        });
        localStorage.removeItem("vinFilter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            this.saveFilterToLocalStorage();
        });
    }

    private saveFilterToLocalStorage = () => {
        // if (this.state.filteredCustomerId == "-1"
        //     && this.state.filteredManagerIds == null
        //     && this.state.searchText == ""
        //     && this.state.source == null
        //     && this.state.selectedCustomerId == undefined
        //     && this.state.dateTo == null && this.state.dateFrom == null) {
        //     localStorage.removeItem("ordersFilter");
        //     return;
        // }
        // localStorage.setItem("ordersFilter", JSON.stringify({
        //     source: this.state.source,
        //     filteredManagerIds: this.state.filteredManagerIds,
        //     filteredCustomerId: this.state.filteredCustomerId,
        //     selectedCustomerId: this.state.selectedCustomerId,
        //     selectedCustomerName: this.state.selectedCustomerName,
        //     searchText: this.state.searchText,
        //     dateFrom: this.state.dateFrom,
        //     dateTo: this.state.dateTo,
        //     filterFormIsOpened: true,
        //     onlyUnAccepted: this.state.onlyUnAccepted,
        //     showHidden: this.state.showHidden
        // }));
    }
    private openSelectCustomerModal = () => {
        if (this.state.source == "")
            this.customersStore._rootStore.notificationStore.addNotification("Источник не выбран!", NotificationLevel.error);
        else
            this.setState({ selectCustomerModalIsOpened: true });
    }



    render() {
        return [
            <TablePageHeader header="VIN-запросы" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                    <Form.Control size="sm"
                        placeholder="Номер..."
                        style={{ marginLeft: "15px", width: "250px" }}
                        value={this.state.searchText}
                        name="searchText"
                        onChange={wrapInput(this.changeFilter)}
                    />
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>

                                            {/* <Form.Group controlId="filterForm.SelectSource">
                                                <Form.Label>Источник</Form.Label>
                                                <Form.Control as="select" size="sm"
                                                    value={this.state.source}
                                                    name="source"
                                                    onChange={wrapInput(this.changeFilter)}>

                                                    <option value="">Все</option>
                                                    <option value={SOURCES_AS61}>As61.ru</option>
                                                    {this.authStore.isCallCentre ? <option value={SOURCES_AB61}>Ab61.ru</option>
                                                        : []}
                                                    <option value={SOURCES_ABTEKA}>Abteka.ru</option>
                                                </Form.Control>
                                            </Form.Group> */}
                                        </Col>
                                        {this.authStore.isCallCentre ?
                                            <Col sm="3">
                                                <Form.Group controlId="filterForm.SelectClient">
                                                    <Form.Label>Контрагент</Form.Label>
                                                    <div className="form-inline" style={{
                                                        border: "1px solid #d8d8d8",
                                                        borderRadius: "3px",
                                                        padding: "0px 2px",
                                                        fontSize: "11pt",
                                                        cursor: "pointer"
                                                    }}
                                                        onClick={this.openSelectCustomerModal}>
                                                        <div style={{ width: "100%", marginLeft: "-40px", paddingLeft: "40px" }}>
                                                            {this.state.selectedCustomerId == undefined ?
                                                                <span>Не выбрано</span> :
                                                                <span>{this.state.selectedCustomerName}</span>}

                                                        </div>
                                                        {this.state.selectedCustomerId == undefined ? [] :
                                                            <Button type="button" variant="link" size="sm" style={{ marginLeft: "-3px", marginRight: "-12px" }}
                                                                onClick={(e: any) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.setState({
                                                                        selectedCustomerId: undefined,
                                                                        selectedCustomerName: undefined
                                                                    }, () => {
                                                                        this.saveFilterToLocalStorage()
                                                                    });
                                                                }}>
                                                                <FontAwesomeIcon icon="times" style={{ color: "black" }} />
                                                            </Button>
                                                        }
                                                        <Button type="button" variant="link" size="sm" style={{
                                                            marginLeft: this.state.selectedCustomerId == undefined ? "9px" : "0"
                                                        }}>
                                                            <FontAwesomeIcon icon="caret-down" style={{ color: "black" }} />
                                                        </Button>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            : []
                                        }
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row > : [],
            <Row key="2">
                <Col sm={12}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">№</th>
                                <th className="text-center">Время</th>
                                <th className="text-center">Источник</th>
                                <th className="text-center">Сообщений</th>
                                <th className="text-center">Контрагент</th>
                                <th className="text-center">Номер телефона</th>
                                <th className="text-center">VIN</th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={7}
                            page={this.state.currentPage}
                            totalCount={this.state.totalCount}
                            pageSize={40}
                            move={"/sales/vinqueries"}
                        />
                        <tbody>
                            {this.state.vinQueries.map((item, index) => <tr key={index} className={item.isOpened ? "" : "table-warning"}>
                                <td className="text-center" >
                                    <LinkContainer to={`/sales/vinquerydetails/${item.id}/${this.backUrl}`}>
                                        <Link to={`/sales/vinquerydetails/${item.id}/${this.backUrl}`}>{item.id}</Link>
                                    </LinkContainer>
                                </td>
                                <td className="text-center">{formatDate(item.dateAdded)}</td>
                                <td className="text-center">{item.sourceSite}</td>
                                <td className="text-center">{item.messagesCount}</td>
                                <td className="text-center">{`${item.customerName} (${item.customerPhone})`}</td>
                                <td className="text-center">{item.comment}</td>
                                <td className="text-center">{item.vin}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row >,
            <SelectCustomerModal
                key="3"
                customersStore={this.customersStore}
                isOpened={this.state.selectCustomerModalIsOpened}
                source={this.state.source || "abteka"}
                onCustomerSelected={(customer: Customer) => {
                    this.setState({
                        selectCustomerModalIsOpened: false,
                        selectedCustomerId: customer.id,
                        selectedCustomerName: customer.friendlyName,
                    }, () => {
                        this.saveFilterToLocalStorage()
                    });
                }}
                openNewCustomerModal={() => { }}
                onHideHandler={() => { this.setState({ selectCustomerModalIsOpened: false }) }}
            />
        ]
    }
}